import { type ComponentProps } from 'react';

import { cn } from '@/util/utils';

/**
 * ui-textarea: the input's surface, border and focus glow, 12px padding, 126px minimum. 16px on
 * touch, as the input is, because iOS zooms the page into any field set smaller (ALS-263).
 */
function Textarea({ className, ref, ...props }: ComponentProps<'textarea'>) {
    return (
        <textarea
            data-slot="textarea"
            ref={ref}
            className={cn(
                'bg-card text-foreground border-input placeholder:text-muted-foreground flex min-h-[126px] w-full resize-y rounded-md border p-3 text-sm shadow-xs pointer-coarse:text-base',
                'transition-[color,box-shadow,border-color] duration-(--duration-fast) outline-none',
                'focus-visible:border-ring focus-visible:shadow-[0_0_0_3px_var(--outline)]',
                'aria-invalid:border-destructive aria-invalid:focus-visible:shadow-[0_0_0_3px_var(--outline-destructive)]',
                'disabled:bg-muted disabled:text-text-locked disabled:cursor-not-allowed disabled:shadow-none',
                className,
            )}
            {...props}
        />
    );
}

export { Textarea };
